var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM28.435 12.1316L9.1517 19.5666C7.83003 20.0833 7.85336 20.8149 8.92503 21.1549L13.8617 22.6949L25.3134 15.4849C25.845 15.1316 26.3384 15.3316 25.935 15.6866L16.6684 24.0583L16.3134 29.1466C16.83 29.1466 17.055 28.9216 17.3217 28.6549L19.7334 26.3316L24.7334 30.0166C25.645 30.5333 26.2967 30.2666 26.54 29.1699L29.8234 13.7016L29.8217 13.7033C30.1117 12.3499 29.33 11.8083 28.435 12.1316Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderTelegram);
export default __webpack_public_path__ + "static/media/header-telegram.6a2f93b3a509697b56e2d8e37677c0d7.svg";
export { ForwardRef as ReactComponent };